import { BrowserRouter, Routes, Route } from "react-router-dom";
import SiteLayout from "@/components/SiteLayout";
import HomePage from "@/pages/HomePage";
import WebsitesOfferPage from "@/pages/WebsitesOfferPage";

function App() {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<SiteLayout />}>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/websites" element={<WebsitesOfferPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
